export enum PaymentModuleName {
  BraintreeApplePay = 'BraintreeApplePay',
  BraintreeCard = 'BraintreeCreditCard',
  BraintreeGooglePay = 'BraintreeGooglePay',
  BraintreePayPal = 'BraintreePaypal',
  BraintreePayPalPayLater = 'BraintreePaypalPaylater',
  DirectDebitLSV = 'DirectDebitLSV',
  WorldpayBancontact = 'BancontactWorldpay',
  WorldpayCard = 'CreditCardWorldpay',
  WorldpayIdeal = 'IdealWorldpay',
  PaymentAtSubsidiary = 'PaymentInSubsidiary',
  Sepa = 'DirectDebitSEPA',
  Transbank = 'Transbank',
  ECommerceConnect = 'ECommerceConnect',
  NuveiTwint = 'NuveiTwint',
  FlutterwaveCreditCard = 'FlutterwaveCreditCard',
  NuveiCreditCard = 'NuveiCreditCard',
  BraintreeSepa = 'BraintreeSepa',
  PaymentOnDelivery = 'PaymentOnDelivery',
  BankTransfer = 'BankTransfer',
  Finvoice = 'Finvoice',
  TwoCTwoP = 'TwoCTwoP',
  ProcessingKZ = 'ProcessingKZ',
  Yookassa = 'Yookassa',
  RazorPay = 'RazorPay',
  DirectDebitPostFinance = 'DirectDebitPostFinance',
  DenizBank = 'DenizBank',
  PaymentInSubsidiaryCashOnPickup = 'PaymentInSubsidiaryCashOnPickup',
  PaymentInSubsidiaryCardViaTerminalOnPickup = 'PaymentInSubsidiaryCardViaTerminalOnPickup',
  PayByInvoice = 'PayByInvoice',
  WorldpayKlarna = 'KlarnaWorldpay',
  WorldpayJCB = 'WorldpayJCB',
}
